import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import { ScrollView } from '../../../../common/components/atoms';

import { wait } from '../../../../common/helper/commonHelper.js';
import speedIcon from '../../../components/atoms/data/speed-icon.svg';

class Training2 extends Component {
    constructor(props) {
        super(props);

        this.refAudio = React.createRef();
        this.refScroll = React.createRef();
        this.testIndex = 0;
        this.autoplayIndex = 0;
        this.state = {
            displayEnglish: true,
            displayJapanese: true,
            executeTest: 0,
            executeAutoPlay: 0,
            test: [],
            audios: [],
            loadedAudio: 0,
            loading: true,
            setting: false,
            playbackRate: this.props.playbackRate ? this.props.playbackRate : 1,
        };
    }
    componentDidMount() {
        this.reset();
    }

    loadStart = () => {
        if (this.props.vocabulary.length === 0) {
            this.setState({
                loading: false
            });
            return;
        }
        for (let key in this.props.vocabulary) {
            if (this.props.vocabulary[key].audio) {
                this.props.dispatch({
                    type: "DownloadAudio_Saga",
                    subjectID: this.props.subject.id,
                    id: key,
                    name: this.props.vocabulary[key].audio,
                    mode: 0,
                    onSuccess: this.onSuccessAudio,
                    onFailure: this.onFailure,
                });
            } else {
                let loadedAudio = this.state.loadedAudio + 1;
                this.setState({
                    loadedAudio: loadedAudio,
                    loading: !this.checkLoadEnded(loadedAudio)
                })
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.isCurrent && !this.props.isCurrent) {
            this.refAudio.current.pause();
            if (this.state.executeAutoPlay === 1 || this.state.executeTest === 1) {
                this.autoplayIndex = 0;
                this.testIndex = 0;

                this.stop();

                let test = this.state.test;
                for (let key in this.props.vocabulary) {
                    test[key] = 0;
                }
                this.setState({
                    executeAutoPlay: 0,
                    executeTest: 0,
                    test: test
                });
            }
        }
        if (prevState.loading && !this.state.loading) {
            if (!this.state.loading) {
                let test = this.state.test;
                for (let key in this.props.vocabulary) {
                    test[key] = 0;
                }
                this.setState({
                    test: test
                });
            }
        }
    }

    checkLoadEnded = (loadedAudio) => {
        if (loadedAudio < Object.keys(this.props.vocabulary).length) {
            return false;
        }
        return true;
    }

    onSuccessAudio = (audio, id) => {
        let audios = this.state.audios;
        let loadedAudio = this.state.loadedAudio + 1;
        audios[id] = audio;
        this.setState({
            audios: audios,
            loadedAudio: loadedAudio,
            loading: !this.checkLoadEnded(loadedAudio)
        })
    }
    onFailure = (status, error) => {
        let loadedAudio = this.state.loadedAudio + 1;
        this.setState({
            loadedAudio: loadedAudio,
            loading: !this.checkLoadEnded(loadedAudio)
        })
    }

    getSortedList(list) {
        list.sort((a, b) => {
            if (a.order < b.order) return -1;
            if (a.order > b.order) return 1;
            return 0;
        });
        return list;
    }

    reset() {
        let test = [];
        let audios = [];
        for (let key in this.props.vocabulary) {
            test[key] = 0;
            audios[key] = "";
        }
        this.testIndex = 0;
        this.autoplayIndex = 0;
        this.setState({
            test: test,
            audios: audios,
            loadedAudio: 0,
            loading: true,
            executeTest: 0,
            executeAutoPlay: 0,
        });
    }

    onClickPlay(e, index) {
        if (this.state.executeAutoPlay === 1){
            this.stop();
            this.onClickAllPlay(e, index);
        }else if (this.state.executeTest === 1){
            this.stop();
            this.onClickTest(e, index);
        }else {
           this.setActive(index);
           this.play(index);
        }
    }

    setActive(index) {
        this.setState({ active: index });
        setTimeout((e) => {
            this.setState({ active: -1 });
        }, 300);
    }

    play(index) {
        try {
            if (this.state.audios[index]) {
                this.refAudio.current.src = this.state.audios[index];
                this.refAudio.current.load();
                this.refAudio.current.playbackRate = this.state.playbackRate;
                this.refAudio.current.play();
            }
        } catch (e) {
        }
    }
    stop() {
        this.refAudio.current.pause();
    }

    createText() {
        let ret = [];
        let index = 0;
        let active = 0;
        const vocabulary = this.props.vocabulary;
        for (let key in vocabulary) {
            if (this.state.active === index) {
                active = 1;
            } else {
                active = 0;
            }
            const i = index;
            ret.push(
                <WordRow id={"#vocabulary" + key} key={index} onClick={e => this.onClickPlay(e, i)} active={active}>
                    <WordRowIcon>
                        <i className="far fa-play-circle" />
                    </WordRowIcon>
                    <Word type={1} Display={this.state.displayEnglish}>
                        <span>{vocabulary[key].textEn}</span>
                    </Word>
                    <Word Display={this.state.displayJapanese && this.state.test[key] === 0}>
                        <span>{vocabulary[key].textJp}</span>
                    </Word>
                </WordRow>
            )
            index++;

        }

        return ret;
    }

    onClickLanguage(e, index) {
        if (index === 0) {
            if (this.state.displayEnglish) {
                if (this.state.executeTest === 1) return;
                this.setState({ displayEnglish: false });
            } else {
                this.setState({ displayEnglish: true });
            }
        } else {
            if (this.state.displayJapanese) {
                if (this.state.executeTest === 1) return;
                this.setState({ displayJapanese: false });
            } else {
                this.setState({ displayJapanese: true });
            }
        }
    }

    onClickAllPlay = (e, index) => {
        if (this.state.executeTest === 1){
            this.onClickTestEnd();
        }
        this.autoplayIndex = index;
        if (index === 0){ this.refScroll.current.scrollTo(0); }

        this.play(this.autoplayIndex);
        this.setActive(this.autoplayIndex);
        this.setState({ executeAutoPlay: 1 });
    }
    onClickAllStop = (e) => {
        if (this.state.executeAutoPlay === 1) {
            this.autoplayIndex = 0;

            this.stop();
            this.setState({ executeAutoPlay: 0 });
        }
    }

    onClickTest = (e, index) => {
        if (this.state.executeAutoPlay === 1){
            this.onClickAllStop();
        }
        this.testIndex = index;
        if (index === 0){ this.refScroll.current.scrollTo(0); }

        this.play(this.testIndex);

        let test = this.state.test;
        for (let key in this.props.vocabulary) {
            if (key < index) {
                test[key] = 0;
            } else {
                test[key] = 1;
            }
        }
        this.setState({
            displayEnglish: true,
            displayJapanese: true,
            executeTest: 1,
            test: test
        });
    }
    onClickTestEnd = (e) => {
        if (this.state.executeTest === 1) {
            this.testIndex = 0;

            this.stop();

            let test = this.state.test;
            for (let key in this.props.vocabulary) {
                test[key] = 0;
            }
            this.setState({ executeTest: 0, test: test });
        }
    }

    onEnded = (e) => {
        const max = Object.keys(this.props.vocabulary).length;

        // 再生時のインターバル設定
        let testDisplayInterval = 1000;     // 英語を読んでから日本語を表示するまでのインターバル
        let testPlayInterval = 1500;        // 日本語が表示されてから次の英語を読むまでのインターバル
        let autoPlaytestInterval = 5000;    // まとめて再生時のインターバル

        // インターバルに速度調整を適用
        let playbackRate = this.state.playbackRate;
        testDisplayInterval = Math.floor(testDisplayInterval / playbackRate);
        testPlayInterval = Math.floor(testPlayInterval / playbackRate);
        autoPlaytestInterval = Math.floor(autoPlaytestInterval / playbackRate);

        if (this.state.executeTest === 1) {
            (async() => {
                let test = this.state.test;
                test[this.testIndex] = 0;
                await wait(testDisplayInterval);
                this.setState({ test: test });
    
                this.testIndex++;
                if (this.testIndex === max) {
                    this.setState({ executeTest: 0 });
                } else {
                    let a = document.getElementById("#vocabulary" + this.testIndex).getBoundingClientRect();
                    let height = this.refScroll.current.getBodyHeight();
                    if ((a.top + a.height) > (height + 100)) {
                        this.refScroll.current.scroll(a.height);
                    }
                    await wait(testPlayInterval);
                    if (this.state.executeTest === 1) {
                        this.play(this.testIndex);
                    }
                }
            })()
        }
        if (this.state.executeAutoPlay === 1) {
            this.autoplayIndex++;
            if (this.autoplayIndex === max) {
                this.setState({ executeAutoPlay: 0 });
            } else {
                (async() => {
                    await wait(autoPlaytestInterval);
                    if (this.state.executeAutoPlay === 1){
                        let a = document.getElementById("#vocabulary" + this.autoplayIndex).getBoundingClientRect();
                        let height = this.refScroll.current.getBodyHeight();
                        if ((a.top + a.height) > (height + 100)) {
                            this.refScroll.current.scroll(a.height);
                        }
                        this.setActive(this.autoplayIndex);
                        this.play(this.autoplayIndex);
                    }
                })()
            }
        }
    }

    onClickSettingbutton = (e) => {
        if (this.state.setting) {
            this.setState({ setting: false });
        } else {
            this.setState({ setting: true });
        }
    }
    onClickSelector = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const rate = Number(e.target.innerText);
        this.refAudio.current.playbackRate = rate;
        this.setState({ 
            playbackRate: rate, 
            setting: false 
        });

        if (this.props.onChangePlaybackRate) {
            this.props.onChangePlaybackRate(rate);
        }
    }
    createSpeedSelector() {
        let speed = 0.5;
        let selector = [];
        while (1) {
            let text = (speed + '.0').slice(0, 3);
            let style = speed === this.state.playbackRate ? { backgroundColor: "#f9f9f9" } : { background: "transparent" };
            selector.push(
                <Speed key={speed} style={style} onClick={this.onClickSelector}>{text}</Speed>
            )
            speed += 0.1;
            speed = Math.round(speed * 10) / 10;
            if (speed > 2.0) {
                break;
            }
        }
        return selector;
    }

    render() {
        const btn_on = (
            <i className="fas fa-toggle-on fa-rotate-180"></i>
        );
    
        const btn_off = (
            <i className="fas fa-toggle-on"></i>
        );
        // header:110 title:40 play:50 test:50 footer:50
        const height = (window.innerHeight - 110 - 40 - 50 - 50 - 50) + "px";

        const propsScroll = {
            width: '100%',
            height: height,
            contents: this.createText()
        }
        const imgEn = this.state.displayEnglish ? btn_on : btn_off;
        const imgJa = this.state.displayJapanese ? btn_on : btn_off;
        const speed = this.state.playbackRate.toFixed(1);

        let playIcon;
        let testIcon;
        if (this.state.executeAutoPlay) {
            playIcon = (
                <Control onClick={this.onClickAllStop}>
                    <ControlIcon>
                        <i className="fas fa-stop"></i>
                    </ControlIcon>
                    <div>
                        停止する
                    </div>
                </Control>
            );
        } else {
            playIcon = (
                <Control onClick={e => this.onClickAllPlay(e, 0)}>
                    <ControlIcon>
                        <i className="fas fa-play"></i>
                    </ControlIcon>
                    <div>
                        英語をまとめて再生する
                    </div>
                </Control>
            );
        }
        if (this.state.executeTest) {
            testIcon = (
                <Control onClick={this.onClickTestEnd}>
                    <div>
                        終了する
                    </div>
                </Control>
            );
        } else {
            testIcon = (
                <Control onClick={e => this.onClickTest(e, 0)}>
                    <div>
                        テストする
                    </div>
                </Control>
            );
        }
        return (
            <Body Width={this.props.width} Height={this.props.height}>
                <Titles>
                    <Languagewrap>
                        <Language type={1}>
                            英語
                        </Language>
                        <LanguageControl onClick={e => this.onClickLanguage(e, 0)}>
                            ON
                            <LanguageChildImg>{imgEn}</LanguageChildImg>
                            OFF
                        </LanguageControl>
                        <Language>
                            日本語
                        </Language>
                        <LanguageControl onClick={e => this.onClickLanguage(e, 1)}>
                            ON
                            <LanguageChildImg>{imgJa}</LanguageChildImg>
                            OFF
                        </LanguageControl>
                    </Languagewrap>
                </Titles>
                <PlayControls>
                    <PlayControl>
                        {playIcon}
                    </PlayControl>
                    <SpeedControlWrap>
                        <SpeedControl onClick={this.onClickSettingbutton}>
                            <SpeedIcon>
                                <img src={speedIcon} alt="img" width="20px" height="20px" />
                            </SpeedIcon>
                            <TextField>
                                ×{speed}
                            </TextField>
                        </SpeedControl>

                        <Setting setting={this.state.setting}>
                            <Selector>{this.createSpeedSelector()}</Selector>
                        </Setting>
                    </SpeedControlWrap>
                </PlayControls>
                <ScrollView ref={this.refScroll} {...propsScroll} />
                <TestControls>
                    <TestControl>
                        {testIcon}
                    </TestControl>
                </TestControls>
                <audio ref={this.refAudio} autobuffer="true" id="audio" onEnded={this.onEnded} />
                <Loading Display={this.state.loading}>
                    <LoadingText>音声ファイル取得中</LoadingText>
                </Loading>
            </Body>
        );
    }
}

export { Training2 };

const Body = styled.div`
    width: ${props => (props.Width)};
    height: ${props => (props.Height)};
    position: relative;
`;
const Titles = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    height: 39px;
    align-items: center;
    border-bottom: 1px solid #dddddd;
`;

const WordRow = styled.div`
    display: flex;
    align-items: center;

    background-color: ${props => props.active ? '#eaf3ff' : 'transparent'};
    transition-duration:0.3s;
    transition-timing-function: ease-in-out;

    font-size: 20px;
    position: relative;
`;
const WordRowIcon = styled.div`
    position: absolute;
    top: 50%;
    left: 20px;
    transform: translateY(-50%);
    color: #0077FF;
    font-weight: 400;
`;
const Word = styled.div`
    width: 50%;
    min-height: 40px;
    padding: 3px 6px;
    display: flex;
    justify-content: start;
    align-items: center;
    margin-left: ${props => props.type ? '40px' : '0'};
    color: ${props => props.type ? '#0077FF' : '#000'};
    opacity: ${props => props.Display ? '1' : '0'};
    will-change: opacity;
    transition-duration: 0.3s;
`;

const Languagewrap = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 20px;
`;

const Language = styled.div`
    color: ${props => props.type ? '#0077FF' : '#000'};
`;

const LanguageControl = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: auto 10px;
    font-size: 15px;
    line-height: 30px;
`;

const LanguageChildImg = styled.div`
    flex: 1;
    text-align: center;
    display: block;
    margin: auto 2px;
    font-size: 30px;
    color: #0077FF;
`;

const PlayControls = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    height: 50px;
    align-items: center;
`;

const PlayControl = styled.div`
    width: 180px;
    height: 30px;
    color: #000;
    background-color: #eeeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    margin-left: 20px;
    margin-right: 20px;
`;

const TestControls = styled.div`
    display: flex;
    height: 50px;
    align-items: center;
`;

const TestControl = styled.div`
    width: 150px;
    height: 30px;
    color: #fff;
    background-color: #0077FF;
    justify-content: center;
    margin: 5px auto;
    align-items: center;
    text-align: center;
    border-radius: 5px;
    font-size: 15px;
`;

const Control = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    :nth-of-type(n+2) {
        border-left: 1px solid #fff;
    }
`;
const ControlIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 42px;
    color: #0077FF;
    margin-right: 5px;
`;

const Loading = styled.div`
    display: ${props => props.Display ? "" : "none"};
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.8);
    position: absolute;
    top: 0;
    left: 0;
`;

const anime = keyframes`
    0% {border: 1px solid #ddd; color: #ddd;}
   50% {border: 1px solid #0077ff; color: #0077ff;}
  100% {border: 1px solid #ddd; color: #ddd;}
`;

const LoadingText = styled.div`
    border: 1px solid #ddd;
    color: #ddd;
    border-radius: 20px;
    background-color: #fff;
    padding: 5px 20px;
    text-align: center;
    position: absolute;
    top: 50px;
    left: 50%;
    max-width: 60%;
    transform: translateX(-50%);
    animation: ${anime} linear 2s;
    animation-iteration-count: infinite;
`;

const SpeedControlWrap = styled.div`
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #eeeeee;
    border-radius: 20px;
    padding: 3px 1px;
    width: 80px;
    font-size: 18px;
`;
const SpeedControl = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
`;
const SpeedIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    color: #0077FF;
    font-size:18px;
`;
const TextField = styled.div`
    margin-bottom: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 20px;
`;
const Speed = styled.div`
    text-align: center;
`;
const Selector = styled.div`
    background-color: #eeeeee;
    border-radius: 5px;
    min-width: 100px;
    height: 200px;
    overflow: auto;
    box-shadow: 0 0 6px rgba(0,0,0,0.3);
`;
const Setting = styled.div`
    position: absolute;
    margin-top: ${props => (props.setting ? '0' : '5px')};
    transform: translate(10%, 60%);
    opacity: ${props => (props.setting ? '1' : '0')};
    transition-duration: 0.2s;

    display: flex;
    justify-content: space-around;
    width: 90px;
    pointer-events: ${props => (props.setting ? '' : 'none')};
    z-index: 99;
`;